export default {
  status: state => state.status,
  loading: state => state.loading,
  error: state => state.error,
  message: state => state.error && state.error.data.message,
  relationships: state => state.relationships,
  personInfo: state => state.personInfo,
  personInfos: state => state.personInfos,
}
